import Vue from "vue";
import __dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/ko";

export const dayjs = __dayjs;

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.locale("ko");
dayjs.tz.setDefault("Asia/Seoul");

/**
 * @param {Vue} Vue
 * @param {*} options
 */
const install = function(Vue, options) {
    Vue.prototype.$dayjs = dayjs;
};

Vue.use({ install });

export default dayjs;
